export const QUESTION_TYPES = [{
  id: 'true_false',
  value: 'True/False',
}, {
  id: 'multiple_choice',
  value: 'Multiple Choice',
}, {
  id: 'text',
  value: 'Open-Ended',
}];
